import Button from "~/components/ui/button/Button";
import Modal from "~/components/ui/modal/Modal";
import { tryCatch } from "~/helpers/tryCatch";

interface DeleteDashboardModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isDeleting: boolean;
}

export const DeleteDashboardModal = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteDashboardModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      modalLabel={<h3>Are you sure you want to remove this dashboard?</h3>}
      closeModal={onClose}
    >
      <div style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}>
        <Button outlined onClick={onClose}>
          Cancel
        </Button>
        <Button
          danger
          withSpinner={isDeleting}
          onClick={async () => {
            await tryCatch(onConfirm());
            onClose();
          }}
        >
          Remove
        </Button>
      </div>
    </Modal>
  );
};
